<template>
  <td :class="'loaderPallet' + (this.number > 8 ? ' lastLoaderPallet' : '')" :style="'vertical-align: top; text-align: left; ' + theCellStyle">
    <div v-if="!half">
      <div class="loaderPalletBackground">
        <div v-if="hasPallet" :class="palletClass" @click="togglePallet">
          <span class="header" v-if="pallet.palletNumber">Pallet #{{ pallet.palletNumber }}</span>
          <span style="float: right;" v-if="pallet.state === 'DELIVERED'"><v-icon style="font-size: 16px !important; color: #004d40;" v-if="pallet.plannedOnShipment">done</v-icon><v-icon style="font-size: 16px !important; color: #CC0000;" v-if="!pallet.plannedOnShipment && !currentShipment.internalTransport">warning</v-icon></span>
          <v-divider style="padding-bottom: 5px;" v-if="pallet.items && showPlannedPallet"/>
          <PalletItems v-if="pallet.items && showPlannedPallet" :items="pallet.items" no-planned-amount="true"/>
        </div>
      </div>
      <div v-if="!hasPallet" :class="noPalletClass" @click="togglePallet">
      </div>
    </div>
    <div v-if="half">
      <div class="loaderPalletBackground">
        <div v-if="hasPallet" :class="palletClass" @click="togglePallet">
          <span class="header" v-if="pallet.palletNumber">Pallet #{{ pallet.palletNumber }}</span>
          <span style="float: right;" v-if="pallet.state === 'DELIVERED'"><v-icon style="font-size: 16px !important; color: #004d40;" v-if="pallet.plannedOnShipment">done</v-icon><v-icon style="font-size: 16px !important; color: #CC0000;" v-if="!pallet.plannedOnShipment && !currentShipment.internalTransport">warning</v-icon></span>
          <v-divider style="padding-bottom: 5px;" v-if="pallet.items && showPlannedPallet"/>
          <PalletItems v-if="pallet.items && showPlannedPallet" :items="pallet.items" no-planned-amount="true"/>
        </div>
      </div>
      <div v-if="!hasPallet" :class="noPalletClass" @click="togglePallet">
      </div>
      <div class="loaderPalletBackground">
        <div style="margin-top: 5px;" v-if="hasPalletSecondRow" :class="palletClassSecondRow" @click="togglePalletSecondRow">
          <span class="header" v-if="palletSecondRow.palletNumber">Pallet #{{ palletSecondRow.palletNumber }}</span>
          <span style="float: right;" v-if="palletSecondRow.state === 'DELIVERED'"><v-icon style="font-size: 16px !important; color: #004d40;" v-if="palletSecondRow.plannedOnShipment">done</v-icon><v-icon style="font-size: 16px !important; color: #CC0000;" v-if="!palletSecondRow.plannedOnShipment && !currentShipment.internalTransport">warning</v-icon></span>
          <v-divider style="padding-bottom: 5px;" v-if="palletSecondRow.items && showPlannedPalletSecondRow"/>
          <PalletItems v-if="palletSecondRow.items && showPlannedPalletSecondRow" :items="palletSecondRow.items" no-planned-amount="true"/>
        </div>
      </div>
      <div style="margin-top: 5px;" v-if="!hasPalletSecondRow" :class="noPalletClassSecondRow" @click="togglePalletSecondRow">
      </div>
    </div>
  </td>
</template>

<script>
import PalletItems from '../components/PalletItems'

export default {
  name: 'LoaderPallet',
  components: { PalletItems },
  props: {
    number: String,
    palletPositions: Array,
    currentPallet: Object,
    currentShipment: Object,
    currentPosition: Number,
    pickupAddress: Object,
    cellStyle: String,
    palletOrders: Array
  },
  created: function () {
  },
  data () {
    return {
      selected: false,
      selectedSecondRow: false
    }
  },
  methods: {
    togglePallet: function () {
      this.selected = !this.selected
      this.$emit('change', { id: this.pallet.id, number: this.pallet.number, pallet: this.pallet, position: this.number })
    },
    togglePalletSecondRow: function () {
      this.selectedSecondRow = !this.selectedSecondRow
      this.$emit('change', { number: this.palletSecondRow.number, pallet: this.palletSecondRow, position: (Number(this.number) + 10) })
    }
  },
  computed: {
    pallet: function () {
      let index = Number(this.number) - 1
      return this.palletPositions[index] ? this.palletPositions[index] : null
    },
    palletSecondRow: function () {
      let index = Number(this.number) + 10 - 1
      return this.palletPositions[index] ? this.palletPositions[index] : null
    },
    deliveryZone: function () {
      let position = Number(this.number)
      if (this.palletOrders) {
        let palletOrders = this.palletOrders.filter(po => po.position === position)
        if (palletOrders && palletOrders.length > 0) {
          return palletOrders[0].deliveryZone
        }
      }
      return 0
    },
    deliveryZoneSecondRow: function () {
      let position = Number(this.number) + 10
      if (this.palletOrders) {
        let palletOrders = this.palletOrders.filter(po => po.position === position)
        if (palletOrders && palletOrders.length > 0) {
          return palletOrders[0].deliveryZone
        }
      }
      return 0
    },
    isPlanned: function () {
      let position = Number(this.number)
      if (this.palletOrders) {
        let palletOrders = this.palletOrders.filter(po => po.position === position)
        if (palletOrders && palletOrders.length > 0) {
          return true
        }
      }
      return false
    },
    half: function () {
      return (this.palletSecondRow && this.palletSecondRow.id) || (this.pallet && this.pallet.half)
    },
    hasPallet: function () {
      return this.currentShipment.internalTransport || (this.pallet && this.pallet.id > 0)
    },
    hasPalletSecondRow: function () {
      return this.palletSecondRow && this.palletSecondRow.id > 0
    },
    loadHere: function () {
      return this.pickupAddress && this.pallet.pickupAddress && this.pickupAddress.id === this.pallet.pickupAddress.id
    },
    theCellStyle: function () {
      return this.cellStyle ? this.cellStyle : ''
    },
    palletClass: function () {
      return (this.half ? 'loaderPalletHalf' : 'loaderPallet') + (this.currentPallet && this.currentPallet === this.pallet ? ' loaderPalletSelected' : '') + (this.loadHere ? '' : ' dontLoadHere') + ' deliveryZone_' + this.deliveryZone
    },
    noPalletClass: function () {
      return (this.half ? 'loaderPalletHalf' : 'loaderPallet') + (this.currentPosition && this.currentPosition === Number(this.number) ? ' loaderPalletSelected' : '') + (this.loadHere ? '' : ' dontLoadHere') + (this.isPlanned ? ' planned' : ' notPlanned')
    },
    palletClassSecondRow: function () {
      return 'loaderPalletHalf' + (this.currentPallet && this.currentPallet === this.palletSecondRow ? ' loaderPalletSelected' : '') + (this.loadHere ? '' : ' dontLoadHere') + ' deliveryZone_' + this.deliveryZoneSecondRow
    },
    noPalletClassSecondRow: function () {
      return 'loaderPalletHalf' + (this.currentPosition && this.currentPosition === Number(this.number) + 10 ? ' loaderPalletSelected' : '') + (this.loadHere ? '' : ' dontLoadHere') + (this.isPlanned ? ' planned' : ' notPlanned') + (this.isPlanned ? ' planned' : ' notPlanned')
    },
    showPlannedPallet: function () {
      return (this.currentShipment && this.currentShipment.fixedPalletPositions) || (this.hasPallet && this.pallet.palletNumber)
    },
    showPlannedPalletSecondRow: function () {
      return (this.currentShipment && this.currentShipment.fixedPalletPositions) || (this.hasPalletSecondRow && this.palletSecondRow.palletNumber)
    }
  }
}
</script>

<style scoped>
  td.loaderPallet {
    padding: 5px 0 5px 5px !important;
    font-size: 10px;
    width: 20%;
  }
  td.loaderPallet .header {
    font-size: 13px;
  }
  td.lastLoaderPallet {
    padding: 5px 5px 5px 5px !important;
  }
  div.loaderPalletBackground {
    padding: 0;
    border: none;
    border-radius: 4px;
    background-color: white;
  }
  div.loaderPallet {
    padding: 5px;
    border: 1px solid #bbbbbb;
    border-radius: 4px;
    min-height: 170px;
    background-color: white;
    cursor: pointer;
    min-width: 10vw;
  }

  div.loaderPalletHalf {
    padding: 5px;
    border: 1px solid #bbbbbb;
    border-radius: 4px;
    min-height: 82px;
    background-color: white;
    cursor: pointer;
  }

  div.loaderPalletSelected {
    border: 1px solid #000000;
    background-color: #004040 !important;
    color: white;
  }
  div.loaderPalletSelected hr {
    border-top: 1px solid #bbbbbb;
  }
  div.dontLoadHere:not(.loaderPalletSelected) {
    /*background: repeating-linear-gradient(-45deg, #ffffff, #ffffff 5px, #f0f0f0 5px, #f0f0f0 10px);*/
  }
  div.notPlanned:not(.loaderPalletSelected) {
    background: repeating-linear-gradient(-45deg, #ffffff, #ffffff 5px, #f0f0f0 5px, #f0f0f0 10px);
  }
</style>



// WEBPACK FOOTER //
// src/components/LoaderPallet.vue